import { motion } from "framer-motion";
import {style} from "./OfflineScreen.css"; // We'll create this CSS file

const OfflineBanner = ({ lastKnownLocation }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ type: "spring", damping: 25, stiffness: 120 }}
      className="offline-banner"
    >
      <div className="connection-status">
        <div className="signal-animation">
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="signal-bar"
              style={{ "--delay": `${i * 0.1}s` }}
            />
          ))}
        </div>
        <div className="offline-content">
          <h3 className="offline-title">Offline Mode</h3>
          <p className="offline-message">
            You're currently offline.
          </p>
          {lastKnownLocation && (
            <p className="location-message">
              <svg className="location-icon" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
              </svg>
              Showing last known location: <span>{lastKnownLocation}</span>
            </p>
          )}
        </div>
      </div>
      <div className="reconnecting-animation">
        <div className="pulse-dot"></div>
        <span>Reconnecting...</span>
      </div>
    </motion.div>
  );
};

export default OfflineBanner;
